module.exports = __webpack_public_path__ + "static/img/product12-1.ce938a94.png";